{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Cancelar",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integrações",
    "DESCRIPTION": "O centro de contacto integra-se com várias ferramentas e serviços para melhorar a eficiência da sua equipa. Explore a lista abaixo para configurar as suas aplicações favoritas. ",
    "LEARN_MORE": "Saber mais sobre integrações",
    "LOADING": "A procurar integrações",
    "CAPTAIN": {
      "DISABLED": "Capitão não está ativo na sua conta.",
      "CLICK_HERE_TO_CONFIGURE": "Clique aqui para configurar",
      "LOADING_CONSOLE": "A carregar a consola capitão...",
      "FAILED_TO_LOAD_CONSOLE": "Falha ao carregar consola capitão. Por favor, atualize e tente novamente."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Eventos subscritos",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Cancelar",
        "DESC": "Os eventos Webhook fornecem informações em tempo real sobre o que está a acontecer na sua conta. Por favor, insira um URL válido para configurar uma chamada de retorno.",
        "SUBSCRIPTIONS": {
          "LABEL": "Eventos",
          "EVENTS": {
            "INBOX_CREATED": "Caixa de entrada criada",
            "CONVERSATION_CREATED": "Conversa criada",
            "CONVERSATION_STATUS_CHANGED": "Estado da conversa alterado",
            "CONVERSATION_UPDATED": "Conversa atualizada",
            "MESSAGE_CREATED": "Mensagem criada",
            "MESSAGE_UPDATED": "Mensagem atualizada",
            "WEBWIDGET_TRIGGERED": "Widget de live-chat aberto pelo utilizador",
            "CONTACT_CREATED": "Contacto criado",
            "CONTACT_UPDATED": "Contacto atualizado",
            "JARABOT_EVENT": "Eventos internos"
          }
        },
        "END_POINT": {
          "LABEL": "URL do webhook",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Por favor, insira um URL válido"
        },
        "EDIT_SUBMIT": "Atualizar webhook",
        "ADD_SUBMIT": "Criar webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Configurar",
      "HEADER": "Configurações do webhook",
      "HEADER_BTN_TXT": "Adicionar novo webhook",
      "LOADING": "A procurar webhooks anexados",
      "SEARCH_404": "Não existem itens correspondentes a esta pesquisa",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhooks são chamadas HTTP que podem ser definidas para cada conta. São acionados por eventos como a criação de mensagens. Pode criar mais de um webhook para esta conta. <br /><br /> Para criar um <b>webhook</b>, clique no botão <b>Adicionar novo webhook</b>. Também pode remover qualquer webhook existente, clicando no botão 'Excluir'.</p>",
      "LIST": {
        "404": "Não há webhooks configurados para esta conta.",
        "TITLE": "Gerir webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Endpoint do webhook",
          "ACTIONS": "Ações"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Editar",
        "TITLE": "Editar webhook",
        "API": {
          "SUCCESS_MESSAGE": "Configuração do webhook atualizada com sucesso",
          "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot, por favor, tente novamente mais tarde"
        }
      },
      "ADD": {
        "CANCEL": "Cancelar",
        "TITLE": "Adicionar novo webhook",
        "API": {
          "SUCCESS_MESSAGE": "Configuração de webhook adicionada com sucesso",
          "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot, por favor, tente novamente mais tarde"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Excluir",
        "API": {
          "SUCCESS_MESSAGE": "Webhook excluído com sucesso",
          "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot, por favor, tente novamente mais tarde"
        },
        "CONFIRM": {
          "TITLE": "Confirmar exclusão",
          "MESSAGE": "Tem a certeza que pretende excluir o webhook? ({webhookURL})",
          "YES": "Sim, excluir ",
          "NO": "Não, manter"
        }
      },
      "DISABLED_BADGE": "Desativado",
      "DISABLED_REASON": "Desativado automaticamente após {count} falhas consecutivas. Último erro: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Ativar",
        "API": {
          "SUCCESS_MESSAGE": "Webhook ativado com sucesso",
          "ERROR_MESSAGE": "Não foi possível ativar o webhook, tente novamente mais tarde"
        }
      }
    },
    "SLACK": {
      "DELETE": "Excluir",
      "DELETE_CONFIRMATION": {
        "TITLE": "Excluir a integração",
        "MESSAGE": "Tem a certeza que pretende excluir a integração? Perderá o acesso às conversas no seu espaço de trabalho Slack."
      },
      "HELP_TEXT": {
        "TITLE": "Como usar a integração da Slack?",
        "BODY": "Com esta integração, todas as suas conversas recebidas serão sincronizadas com o canal ***{selectedChannelName}*** no seu espaço de trabalho Slack. Pode gerir todas as conversas com os seus clientes diretamente no canal e nunca perder uma mensagem.\n\nEstas são as principais funcionalidades da integração:\n\n**Responder a conversas a partir do Slack:** Para responder a uma conversa no canal Slack ***{selectedChannelName}***, escreva a sua mensagem e envie-a como uma thread. A resposta chega ao cliente através do centro de contacto. É assim tão simples!\n\n **Criar notas privadas:** Se pretende criar notas privadas em vez de respostas, comece a sua mensagem com ***`note:`***. Assim, a sua mensagem fica privada e não é visível para o cliente.\n\n**Associar um perfil de agente:** Se a pessoa que respondeu no Slack tiver um perfil de agente no centro de contacto com o mesmo e-mail, as respostas são associadas automaticamente a esse perfil de agente. Assim, pode ver facilmente quem disse o quê e quando. Se a pessoa que responde não tiver um perfil de agente associado, o cliente vê as respostas a partir do perfil do bot.",
        "SELECTED": "selecionado"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Selecionar um canal",
        "UPDATE": "Atualizar",
        "BUTTON_TEXT": "Conectar canal",
        "DESCRIPTION": "O seu espaço de trabalho Slack está agora conectado ao centro de contacto. No entanto, a integração está, de momento, inativa. Para ativar a integração e conectar um canal, por favor, clique no botão abaixo.\n\n**Nota:** Se está a tentar conectar-se a um canal privado, adicione a nossa aplicação ao canal da Slack antes de prosseguir com esta etapa.",
        "ATTENTION_REQUIRED": "Atenção necessária",
        "EXPIRED": "A sua integração com a Slack expirou. Para continuar a receber mensagens na Slack, elimine a integração e conecte o seu espaço de trabalho novamente."
      },
      "UPDATE_ERROR": "Ocorreu um erro ao atualizar a integração, por favor, tente novamente",
      "UPDATE_SUCCESS": "O canal foi conectado com sucesso",
      "FAILED_TO_FETCH_CHANNELS": "Ocorreu um erro ao obter os canais da Slack, por favor, tente novamente"
    },
    "OPEN_AI": {
      "AI_ASSIST": "Assistente de IA",
      "WITH_AI": " {option} com IA ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Sugestão de resposta",
        "SUMMARIZE": "Sumário",
        "REPHRASE": "Melhorar escrita",
        "FIX_SPELLING_GRAMMAR": "Corrigir ortografia e gramática",
        "SHORTEN": "Encurtar",
        "EXPAND": "Expandir",
        "MAKE_FRIENDLY": "Alterar o tom de mensagem para amigável",
        "MAKE_FORMAL": "Usar tom formal",
        "SIMPLIFY": "Simplificar",
        "TRANSLATE": "Traduzir",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Traduzir para o idioma maioritário"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Conteúdo do rascunho",
        "GENERATED_TITLE": "Conteúdo gerado",
        "AI_WRITING": "AI está a escrever",
        "BUTTONS": {
          "APPLY": "Utilizar esta sugestão",
          "CANCEL": "Cancelar"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrar com OpenAI",
        "DESC": "Incorporar recursos IA avançados no seu dashboard utilizando modelos OpenAI GPT. Para começar, insira a chave da API da sua conta OpenAI.",
        "KEY_PLACEHOLDER": "Insira a chave da API da sua conta OpenAI",
        "BUTTONS": {
          "NEED_HELP": "Precisa de ajuda?",
          "DISMISS": "Descartar",
          "FINISH": "Concluir a configuração"
        },
        "DISMISS_MESSAGE": "Pode configurar a integração do OpenAI mais tarde, quando lhe for conveniente.",
        "SUCCESS_MESSAGE": "Integração OpenAI configurada com sucesso"
      },
      "TITLE": "Melhore com IA",
      "SUMMARY_TITLE": "Resumo com IA",
      "REPLY_TITLE": "Responder sugestão com IA",
      "SUBTITLE": "Uma resposta melhorada será gerada usando IA, com base no seu rascunho atual.",
      "TONE": {
        "TITLE": "Tom",
        "OPTIONS": {
          "PROFESSIONAL": "Profissional",
          "FRIENDLY": "Amigável"
        }
      },
      "BUTTONS": {
        "GENERATE": "Gerar",
        "GENERATING": "A gerar...",
        "CANCEL": "Cancelar"
      },
      "GENERATE_ERROR": "Ocorreu um erro ao processar o conteúdo, por favor, verifique a sua chave da API OpenAI e tente novamente"
    },
    "DELETE": {
      "BUTTON_TEXT": "Excluir",
      "API": {
        "SUCCESS_MESSAGE": "Integração removida com sucesso"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Conectar"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Apps de dashboard",
      "HEADER_BTN_TXT": "Adicionar nova app ao dashboard",
      "SIDEBAR_TXT": "<p><b>Apps de dashboard</b></p><p>Apps de dashboard permitem que as organizações incorporem uma aplicação dentro do dashboard para fornecer o contexto aos agentes de suporte ao cliente. Este recurso permite-lhe criar uma aplicação independente e incorporá-la dentro do dashboard para fornecer informações de utilizador, os seus pedidos ou o seu histórico de pagamentos.</p><p>Quando a sua aplicação é incorporada no dashboard, a sua aplicação irá obter o contexto da conversa e do contato como um evento de janela. Implemente um listener para o evento de mensagem na sua página para receber o contexto.</p><p>Para adicionar uma nova app ao dashboard, clique no botão 'Adicionar nova app ao dashboard'.</p>",
      "DESCRIPTION": "Apps de dashboard permitem que as organizações incorporem uma aplicação dentro do dashboard para fornecer o contexto aos agentes de suporte ao cliente. Este recurso permite-lhe criar uma aplicação independente e incorporá-la para fornecer informações de utilizador, os seus pedidos ou o seu histórico de pagamentos.",
      "LEARN_MORE": "Saber mais sobre apps de dashboard",
      "LIST": {
        "404": "Não há apps de dashboard configuradas nesta conta.",
        "LOADING": "A obter apps de dashboard...",
        "TABLE_HEADER": {
          "NAME": "Nome:",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Editar app",
        "DELETE_TOOLTIP": "Apagar app"
      },
      "FORM": {
        "TITLE_LABEL": "Nome",
        "TITLE_PLACEHOLDER": "Digite um nome para a sua app de dashboard",
        "TITLE_ERROR": "É necessário um nome para a app de dashboard",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Insira o URL do endpoint ao qual a sua app está agregada",
        "URL_ERROR": "É necessário um URL válido"
      },
      "CREATE": {
        "HEADER": "Adicionar nova app de dashboard",
        "FORM_SUBMIT": "Submeter",
        "FORM_CANCEL": "Cancelar",
        "API_SUCCESS": "App de dashboard configurada com sucesso",
        "API_ERROR": "Não foi possível criar a app. Por favor, tente novamente mais tarde"
      },
      "UPDATE": {
        "HEADER": "Editar app de dashboard",
        "FORM_SUBMIT": "Atualizar",
        "FORM_CANCEL": "Cancelar",
        "API_SUCCESS": "App de dashboard atualizada com sucesso",
        "API_ERROR": "Não foi possível atualizar as configurações da app. Por favor, tente novamente mais tarde"
      },
      "DELETE": {
        "CONFIRM_YES": "Sim, excluir",
        "CONFIRM_NO": "Não, manter",
        "TITLE": "Confirmar exclusão",
        "MESSAGE": "Tem a certeza que pretende excluir a app - {appName}?",
        "API_SUCCESS": "App de dashboard excluída com sucesso",
        "API_ERROR": "Não foi possível excluir a app. Por favor, tente novamente mais tarde"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Criar/Vincular problema linear",
      "LOADING": "A procurar problemas lineares...",
      "LOADING_ERROR": "Houve um erro ao procurar problemas lineares, por favor, tente novamente",
      "CREATE": "Criar",
      "LINK": {
        "SEARCH": "Pesquisar problemas",
        "SELECT": "Selecionar problema",
        "TITLE": "Endereço",
        "EMPTY_LIST": "Nenhum problema linear encontrado",
        "LOADING": "A carregar",
        "ERROR": "Houve um erro ao procurar problemas lineares, por favor, tente novamente",
        "LINK_SUCCESS": "Problema vinculado com sucesso",
        "LINK_ERROR": "Houve um erro ao vincular o problema, por favor, tente novamente",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Criar/Vincular problema linear",
        "DESCRIPTION": "Crie problemas lineares das conversas, ou vincule os existentes para um rastreamento sem interrupções.",
        "FORM": {
          "TITLE": {
            "LABEL": "Título",
            "PLACEHOLDER": "Inserir título",
            "REQUIRED_ERROR": "Título obrigatório"
          },
          "DESCRIPTION": {
            "LABEL": "Descrição",
            "PLACEHOLDER": "Inserir descrição"
          },
          "TEAM": {
            "LABEL": "Equipa",
            "PLACEHOLDER": "Selecionar equipa",
            "SEARCH": "Procurar equipa",
            "REQUIRED_ERROR": "Equipa obrigatória"
          },
          "ASSIGNEE": {
            "LABEL": "Atribuído",
            "PLACEHOLDER": "Selecionar responsável",
            "SEARCH": "Procurar responsável"
          },
          "PRIORITY": {
            "LABEL": "Prioridade",
            "PLACEHOLDER": "Selecionar prioridade",
            "SEARCH": "Procurar prioridade"
          },
          "LABEL": {
            "LABEL": "Etiqueta",
            "PLACEHOLDER": "Selecionar etiqueta",
            "SEARCH": "Procurar etiqueta"
          },
          "STATUS": {
            "LABEL": "Estado",
            "PLACEHOLDER": "Selecionar estado",
            "SEARCH": "Procurar estado"
          },
          "PROJECT": {
            "LABEL": "Projeto",
            "PLACEHOLDER": "Selecionar projeto",
            "SEARCH": "Procurar projeto"
          }
        },
        "CREATE": "Criar",
        "CANCEL": "Cancelar",
        "CREATE_SUCCESS": "Problema criado com sucesso",
        "CREATE_ERROR": "Houve um erro ao criar o problema, por favor, tente novamente",
        "LOADING_TEAM_ERROR": "Houve um erro ao obter as equipas, por favor, tente novamente",
        "LOADING_TEAM_ENTITIES_ERROR": "Houve um erro ao obter as entidades das equipas, por favor, tente novamente"
      },
      "ISSUE": {
        "STATUS": "Estado",
        "PRIORITY": "Prioridade",
        "ASSIGNEE": "Atribuído",
        "LABELS": "Etiquetas",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Desvincular",
        "SUCCESS": "Problema desvinculado com sucesso",
        "ERROR": "Houve um erro ao desvincular o problema, por favor, tente novamente"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Sim, excluir",
        "CANCEL": "Cancelar"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Enviar mensagem...",
      "EMPTY_MESSAGE": "Ocorreu um erro ao gerar a resposta. Tente novamente.",
      "LOADER": "Captain is thinking",
      "YOU": "Você",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Fazer upgrade agora",
      "CANCEL_ANYTIME": "Pode alterar ou cancelar o plano a qualquer momento"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Por favor, entre em contato com o administrador para atualização."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Cancelar",
      "CREATE": "Criar",
      "EDIT": "Atualização"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Sim, excluir",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Características",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Sim, excluir",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Excluir",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Sim, excluir",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Todas"
      },
      "STATUS": {
        "TITLE": "Situação",
        "PENDING": "Pendente",
        "APPROVED": "Approved",
        "ALL": "Todas"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Desconectar"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Sim, excluir",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Caixa de entrada",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
